module.exports = __webpack_public_path__ + "img/star.29916167.svg";